const Backbone  = window.Backbone;

const SeeAllLinkView = Backbone.View.extend({

    template: _.template(`
        <div class="BrowseSeeAll">
            <a href="<%= href %>" class="BrowseSeeAll-link js-seeAllLink"><%= html('browseSubjects.seeAll', {count: count, display: label}) %></a>
        </div>`),

    initialize() {
        this.listenTo(this.collection, 'sync', () => { this.render(); });
        this.listenTo(this.collection, 'change', () => { this.render(); });
    },

    render() {
        let model = this._getActiveFormatModel();
        this.$el.html(this.template(model.toJSON()));
    },

    labelMap: {
        all         : '',
        ebook       : 'ebook',
        audiobook   : 'audiobook',
        video       : 'video',
        magazine    : 'magazine'
    },

    _getActiveFormatModel() {
        let activeFormats = this.collection.activeFormats();

        let formatModel = this.collection.findWhere({ selected: true }) || _(activeFormats).first();

        let model = formatModel.toJSON();

        // LHTNG-1314 - Override the label to the singular form
        model.label = this.labelMap[model.mediaType];

        // LHTNG-1314 - Remove the format label all together if there is only one option
        if (activeFormats.length === 1) {
            model.label = '';
        }

        if (model.label) {
            model.label = window.html(model.label);
        }

        return new this.collection.model(model); // eslint-disable-line new-cap
    }
});

export default SeeAllLinkView;
